import type { Required } from 'utility-types';

import { TrackingCategory } from '../enums';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { gameDimensions } from './gameDimensions';
import type { LaunchParams } from './types';

export const trackTrailer = (
  context: TrackingContextValue,
  { action, game, index, totalGames = 1, buttonName = 'Trailer' }: Required<LaunchParams, 'action'>
) => {
  GAEvent(
    { action, label: game.name },
    { ...context, category: TrackingCategory.Casino, ...gameDimensions(game, index) }
  );
};
